export default function DashboardPastDeadline() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-[#646464]'>Unfortunately, it looks like the IRS filing deadline for the SETC claim has passed. At this time, we’re unable to proceed with your claim. If you have any questions or concerns regarding this update, please reach out to our support team for further assistance.</p>
      </div>
    </div>
  )
}